import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { ClockDigitalWidget } from 'htv-lib'
import { map, Subscription, timer } from 'rxjs'
import moment from 'moment'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'

@Component({
  selector: 'app-clock-digital',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './clock-digital.component.html',
  styleUrls: [],
})
export class ClockDigitalComponent {
  subscriptions = new Subscription()
  @Input() config!: ClockDigitalWidget
  time$ = timer(0, 1000).pipe(map(() => moment().format('LT')))
}
